module.exports = __webpack_public_path__ + "static/log-top5-2025-439ba91cdfd571b5454a50dd5657b002.png";